var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g, _path39, _g2, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.106 17.926c.515-2.026-.207-3.99-1.614-4.388-1.407-.398-2.964.923-3.48 2.95-.514 2.026.209 3.99 1.615 4.388 1.407.397 2.965-.923 3.48-2.95Z",
  fill: "#343A3F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m2.628 20.882 2.076.587 1.865-7.338-2.077-.587-1.864 7.338Z",
  fill: "#343A3F"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.128 18.497c.515-2.027-.208-3.991-1.615-4.389-1.406-.397-2.964.923-3.479 2.95-.515 2.026.208 3.99 1.615 4.388 1.406.397 2.964-.923 3.479-2.95Z",
  fill: "#A2A9B0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.276 8.584 7.038 9.603s.128-.742.38-1.019c.381-.418.858 0 .858 0Z",
  fill: "#E9E9EA"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.574 15.27c.514-2.026-.209-3.99-1.615-4.388-1.407-.398-2.964.923-3.48 2.95-.514 2.025.209 3.99 1.615 4.387 1.407.398 2.965-.923 3.48-2.949Z",
  fill: "#343A3F"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m32.096 18.218 2.076.587 1.865-7.338-2.076-.587-1.865 7.338ZM16.189 20.762c.515-2.026-.208-3.99-1.615-4.388-1.406-.397-2.964.923-3.479 2.95-.515 2.026.208 3.99 1.614 4.388 1.407.397 2.965-.923 3.48-2.95Z",
  fill: "#343A3F"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "m12.71 23.718 2.077.587 1.864-7.338-2.076-.587-1.864 7.338Z",
  fill: "#343A3F"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "m38.28 14.305-4.035-.778-14.052 4.516-1.236 2.445-5.487-.41.453-4.119 23.588-6.928L38.583 12l-.302 2.305Z",
  fill: "#001230"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "m39.559 8.242-.36-1.983s-.153-.537-.702-.727c-.45-1.16-1.492-2.7-2.36-3.025-2.409-.902-7.246-3.02-9.93-2.393-4.85 1.131-8.338 2.105-11.504 3.003-2.773.786-7.011 5.892-7.011 5.892S2.503 11.048.6 12.859c-.557.53-.51 3.663 0 5.936.27 1.208 9.505 3.53 11.334 3.37l.784-.186c-.05-.838.043-2.193.303-3.152.553-2.041 2.376-3.267 3.74-3.03 1.3.224 2.627 1.726 2.195 4.69l1.262-.593a88.212 88.212 0 0 1 10.617-2.999l1.264-.215c0-.925.05-2.226.347-3.229.693-2.345 2.717-3.238 4.043-2.863 1.25.354 2.005 1.952 1.791 3.716.431-.419.223-.431.913-1.284.25-.31.677-2.007.675-3.598 0-.494-.31-1.18-.31-1.18Z",
  fill: "url(#a)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M22.547 6.12c-4.854-.678-7.908-1.733-8.903-2.534-1.753.978-3.588 2.669-5.952 5.427 0 1.318 3.194 2.756 9.435 2.908 2.057-2.556 4.205-5.265 5.42-5.8ZM18.337 12.616c5.493-1.307 11.726-3.491 16.712-5.668 1.045-.457.814-2.235.786-2.86-.027-.583-.145-1.053-.786-.927-2.306.454-11.303 2.845-12.179 3.578-2.39 2.002-4.533 5.877-4.533 5.877Z",
  fill: "#121619"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M37.595 15.848c.515-2.026-.208-3.99-1.614-4.388-1.407-.398-2.965.923-3.48 2.95-.514 2.026.208 3.99 1.615 4.388 1.407.397 2.964-.923 3.48-2.95Z",
  fill: "#A2A9B0"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M36.95 15.671c.384-1.513-.155-2.98-1.206-3.277-1.05-.296-2.213.69-2.597 2.203-.385 1.513.155 2.98 1.205 3.276 1.05.297 2.213-.689 2.598-2.202Z",
  fill: "#E9E9EA"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "m36.192 15.01.48.801c.133.22-.052.603-.281.584l-.834-.069c-.1-.008-.206.067-.27.19l-.537 1.036c-.147.284-.447.242-.456-.064l-.035-1.116c-.004-.133-.07-.232-.167-.251l-.813-.16c-.222-.045-.222-.454 0-.625l.813-.62a.465.465 0 0 0 .167-.345l.035-1.135c.01-.311.309-.522.456-.321l.537.732c.064.088.17.102.27.038l.834-.541c.229-.148.414.13.282.425l-.481 1.073c-.058.128-.058.273 0 .369Z",
  fill: "#343A3F"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M35.464 15.245c.084-.33-.034-.651-.264-.716-.23-.065-.484.15-.568.481-.084.331.034.652.264.717.23.065.484-.15.568-.482Z",
  fill: "#E9E9EA"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M18.21 21.325c.515-2.026-.208-3.991-1.615-4.389-1.406-.397-2.964.924-3.479 2.95-.515 2.026.208 3.99 1.614 4.388 1.407.398 2.965-.923 3.48-2.95Z",
  fill: "#A2A9B0"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M17.564 21.148c.385-1.513-.155-2.98-1.205-3.277-1.05-.297-2.213.69-2.598 2.202-.384 1.513.156 2.98 1.206 3.277 1.05.296 2.213-.69 2.597-2.202Z",
  fill: "#E9E9EA"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "m16.806 20.487.481.8c.132.22-.053.604-.282.585l-.834-.07c-.1-.008-.206.067-.27.19l-.537 1.037c-.146.283-.447.242-.456-.064l-.034-1.116c-.005-.133-.07-.232-.167-.252l-.813-.16c-.223-.044-.223-.454 0-.624l.813-.62a.465.465 0 0 0 .167-.345l.034-1.135c.01-.312.31-.523.457-.322l.536.733c.064.087.17.102.27.037l.834-.54c.229-.149.414.13.282.424l-.48 1.073c-.058.128-.058.274 0 .37Z",
  fill: "#343A3F"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M16.079 20.722c.084-.331-.034-.652-.264-.717-.23-.065-.484.15-.568.482-.084.33.034.652.264.716.23.065.484-.15.568-.481Z",
  fill: "#E9E9EA"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M8.057 9.01c1.16 1.43 4.46 2.067 9.466 2.416 0 0 .933-1.35-2.99-2.296-4.183-1.008-6.476-.12-6.476-.12ZM26.444 5.785l.384 3.981.996-.344-.472-3.906-.908.27ZM33.248 7.426l.677-.29-.92-3.269-.647.162.89 3.397Z",
  fill: "#21272A"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M8.858 21.787c.329-.037-.401-1.302-.561-1.486-.379-.436-2.613-1.042-4.625-1.616-1.805-.514-2.447-.627-2.632-.452-.12.113-.506.784-.291.96.5.408 1.653.937 3.321 1.444 1.806.549 4.407 1.193 4.788 1.15Z",
  fill: "#121619"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M18.665 13.861c7.911-2.449 16.27-5.702 20.266-8.08l.447 2.457s-1.389.736-2.853 1.363c-.567.243-2.673.267-3.556 1.951-1.423 2.716-1.514 3.5-2.12 3.932-.529.376-2.576.982-5.67 1.814-1.694.455-5.927 1.688-5.927 1.688-.252-1.48-.588-2.819-1.095-3.87-.238-.496.003-1.098.508-1.255Z",
  fill: "url(#b)"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M12.354 17.912a6.156 6.156 0 0 0-.661 2.419.515.515 0 0 1-.6.49c-.724-.139-1.344-.388-1.79-.82a.633.633 0 0 1 .022-.92c.806-.7 1.706-1.21 2.666-1.599.25-.101.489.18.363.43Z",
  fill: "url(#c)"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M38.08 11.187c-.45-.744-.502-1.345.192-1.788.694-.443 1.062-.938 1.085-.104a7.293 7.293 0 0 1-.72 3.31c-.052.107-.205.08-.221-.04-.04-.3-.088-.969-.336-1.378Z",
  fill: "url(#d)"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M39.198 6.258c-.116-.419-.319-.617-.7-.727l.218 1.481c.06.414.044.838-.05 1.245l-.098.423.991-.439-.36-1.983Z",
  fill: "#21272A"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "m2.61 18.737 2.894.818V18.27l-2.894-.818v1.284Z",
  fill: "#001230"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "m2.428 18.784 2.894.818v-1.284L2.428 17.5v1.284Z",
  fill: "#fff"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "m14.023 5.877 2.183.617.83-.799-2.184-.617-.83.799Z",
  fill: "#21272A"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "m25.765 11.954 1.495-.579-.056.378-1.52.6.081-.4Z",
  fill: "#001230"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "m25.83 11.875 1.496-.578-.056.378-1.52.6.08-.4Z",
  fill: "#303A66"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "m32.167 9.447 1.478-.627-.045.38-1.503.649.07-.402Z",
  fill: "#001230"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "m32.23 9.368 1.478-.626-.045.38-1.502.648.07-.402Z",
  fill: "#303A66"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.44 3.971c-2.827.785-5.643 1.62-6.216 1.837a6.57 6.57 0 0 0-.53.237 10.582 10.582 0 0 0-.25.127l-.014.008-.004.002h-.001l-.01-.02-.01-.02.001-.001.004-.002.015-.008a8.398 8.398 0 0 1 .25-.128c.157-.077.358-.171.534-.238.575-.218 3.394-1.054 6.22-1.838 1.414-.393 2.83-.773 3.969-1.056.57-.142 1.07-.26 1.466-.344.395-.083.689-.132.844-.136l.001.046c-.15.004-.44.052-.837.136a43 43 0 0 0-1.464.342 163.02 163.02 0 0 0-3.968 1.056Z",
  fill: "#231F32"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "m7.7 16.117 3.653-.875s-.117 1.423-.601 1.58c-1.085.354-3.243.924-3.243.924l.19-1.629Z",
  fill: "#21272A"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "m10.095 15.864.923-.262s-.197.896-.353.947l-.753.248.183-.933Z",
  fill: "#EE9059"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M18.823 12.367c7.087-4.738 13.323-6.98 16.808-8.054-.026-.567-.14-1.025-.764-.902-2.245.441-11.004 2.77-11.857 3.483-2.327 1.949-4.187 5.473-4.187 5.473Z",
  fill: "#fff"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M19.46 12.663s.03-.104.375.21c.378.344 1.279.168 1.614 0 .47-.234.857-.67.612-.786-.618-.29-.839-.556-1.043-.548-.204.01-1.558 1.124-1.558 1.124Z",
  fill: "#001230"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M18.917 12.413s.995-1.401 1.478-1.397c.375.003 1.253.079 1.472.742.219.664-.386.997-1.16 1.182-.774.185-1.31.006-1.502-.135-.192-.141-.288-.392-.288-.392Z",
  fill: "#E9E9EA"
})), /*#__PURE__*/React.createElement("mask", {
  id: "e",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 18,
  y: 11,
  width: 4,
  height: 3
}, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M18.917 12.405s.995-1.401 1.478-1.397c.375.003 1.253.079 1.472.742.219.664-.386.997-1.16 1.182-.774.185-1.31.006-1.502-.135a.983.983 0 0 1-.288-.392Z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M21.399 11.096s.085.715-.78.961c-.45.129-1.88.371-1.88.371l.37.85 2.888.169.335-1.628-.551-.96-.382.237Z",
  fill: "#001230"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "f",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 40,
  height: 23
}, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "m39.559 8.239-.36-1.984s-.153-.537-.701-.726c-.45-1.161-1.781-2.834-2.36-3.026-2.44-.808-7.247-3.02-9.93-2.393-4.851 1.132-8.339 2.106-11.504 3.003-2.774.786-7.012 5.892-7.012 5.892S2.503 11.045.6 12.856c-.557.53-.51 3.662 0 5.935.27 1.208 9.505 3.53 11.334 3.37l.784-.186c-.05-.837.043-2.193.303-3.152.553-2.041 2.376-3.267 3.74-3.03 1.3.224 2.627 1.726 2.195 4.69l1.262-.592a88.212 88.212 0 0 1 10.617-3l1.264-.215c0-.925.05-2.226.347-3.228.693-2.346 2.717-3.238 4.043-2.864 1.25.354 2.005 1.953 1.791 3.716.432-.418.223-.43.914-1.284.25-.309.676-2.007.675-3.597 0-.495-.31-1.18-.31-1.18Z",
  fill: "#fff"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#f)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M.967 19.346a87.82 87.82 0 0 1 .204-4.485c.073-.963.071-1.089 1.257-1.413 1.609-.44 4.816-1.873 7.7-2.533 1.401-1.912 4.945-6.367 6.566-6.87C18.823 3.384 27.763 1.103 30.557.39L28.37-.477 13.855 2.217-1.977 13.632l.516 5.26 2.428.454Z",
  fill: "#fff"
}))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M4.35 16.62c.23-.065.348-.386.264-.717-.084-.33-.338-.546-.568-.482-.23.065-.348.386-.264.717.084.331.339.547.568.482Z",
  fill: "#303A66"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.152 8.22c-.095-.938-.213-2.067-.307-2.831l.044-.006c.093.765.211 1.894.306 2.831a420.442 420.442 0 0 1 .164 1.65l.003.029a3.54 3.54 0 0 0 .018.034 3.781 3.781 0 0 1 .207.5c.108.324.205.761.16 1.21a58.66 58.66 0 0 0-.202 2.673c-.049.95-.064 1.839 0 2.329l-.044.006c-.063-.495-.048-1.389 0-2.337.049-.95.13-1.955.203-2.676.044-.44-.051-.87-.158-1.19a3.751 3.751 0 0 0-.22-.52c0-.004-.002-.006-.003-.008l-.001-.002-.003-.004v-.005l.021-.003-.021.003-.003-.034-.01-.098a345.31 345.31 0 0 0-.154-1.552Z",
  fill: "#6F2210"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m33.665 7.497-.982-3.7-.042.012.984 3.707.002.003c.191.313.295.738.318 1.163.023.424-.035.844-.165 1.146l-2.358 4.866c-.248.578-.678 1.005-1.136 1.134L19.27 18.956c-.154-.933-.231-1.979-.303-2.954-.022-.294-.043-.58-.066-.857-.049-.6-.105-1.146-.189-1.588a3.856 3.856 0 0 0-.15-.578 1.183 1.183 0 0 0-.208-.386l-.032.032c.076.086.142.21.2.37.057.16.105.352.147.571.084.439.14.983.189 1.583.023.275.044.562.065.855.073.984.15 2.043.308 2.985l.005.025 11.063-3.141c.474-.134.912-.573 1.164-1.16l2.357-4.864v-.001c.134-.311.193-.74.17-1.169-.023-.428-.128-.86-.324-1.182Z",
  fill: "#6F2210"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m39.368 8.219.01.02.009.021-.074.037a230.233 230.233 0 0 1-.8.397c-.45.222-.922.456-1.018.5-.18.083-.286.303-.367.616a15.827 15.827 0 0 0-.188.849l-.016.076-.004.021-.002.008-.02-.005-.022-.005.001-.007.005-.021.015-.077.053-.255c.043-.2.095-.439.136-.596.08-.313.19-.554.392-.646a98.92 98.92 0 0 0 1.016-.5c.225-.11.443-.22.606-.3l.195-.097.073-.036ZM10.433 16.91l-.007-.022-.007-.022.006-.002a.806.806 0 0 0 .017-.005l.064-.022a31.81 31.81 0 0 1 .976-.306c.282-.084.58-.167.842-.229.26-.06.487-.102.622-.099.097.002.184.06.26.146.075.088.14.208.196.343.11.269.182.6.202.857l-.043.003a3.027 3.027 0 0 0-.199-.842 1.224 1.224 0 0 0-.189-.33c-.07-.082-.147-.129-.228-.13m-2.512.66Zm0 0Zm0 0h.001Zm.001 0 .004-.002Zm.004-.002.017-.005Zm.017-.005.064-.022Zm.064-.022.233-.076Zm.233-.076c.195-.063.46-.146.742-.23Zm.742-.23c.281-.083.58-.166.84-.227Zm.84-.227c.26-.062.482-.101.61-.099ZM17.11 11.898l.017.016.017.015-.023.027-.061.075a301.583 301.583 0 0 1-.684.823 1.207 1.207 0 0 1-.252.198c-.119.076-.27.163-.444.256-.347.187-.784.402-1.231.614-.37.176-.748.35-1.087.507-.48.222-.881.408-1.079.512-.17.09-.543.21-1.003.337-.46.128-1.012.266-1.542.392a97.111 97.111 0 0 1-1.865.425l-.125.027-.033.007-.011.003-.005-.023.005.023h-.005L1.48 14.325l-.004-.005.015-.016-.015.016-.002-.002a.645.645 0 0 0-.026-.03 3.303 3.303 0 0 1-.288-.395c-.156-.251-.313-.588-.304-.914.003-.147.006-.236.038-.312.033-.077.093-.14.203-.24l.028.034c-.11.102-.163.159-.19.225-.028.066-.032.144-.036.294-.008.312.143.638.298.889a3.262 3.262 0 0 0 .303.412l.003.003L7.7 16.085h.006c.008-.003.019-.005.033-.008l.125-.027a94.229 94.229 0 0 0 1.865-.425c.53-.126 1.08-.263 1.54-.391.46-.129.829-.247.995-.334.198-.105.602-.292 1.083-.514.338-.157.715-.33 1.084-.506.447-.212.883-.426 1.23-.613.173-.093.323-.179.44-.255a1.17 1.17 0 0 0 .242-.188l.48-.576.204-.247.061-.075.023-.027Z",
  fill: "#E05333"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M1.492 14.313v1.748s-.868-1.285-.867-2.14c0-.854.253-1.202.253-1.202-.025.556.11 1.096.614 1.594Z",
  fill: "#21272A"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M1.492 16.053C3.22 16.878 5.27 17.4 7.51 17.74l.19-1.63-6.208-1.805v1.748Z",
  fill: "url(#g)"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M.82 13.07s-.152.659-.116.84l.087.427.06-.827-.03-.44Z",
  fill: "#EE9059"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 4.034,
  y1: 0.863,
  x2: 6.759,
  y2: 9.034,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE0AC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FB9346"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 21.467,
  y1: 4.672,
  x2: 25.468,
  y2: 20.034,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.696,
  stopColor: "#EB5837"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#79220E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 9.638,
  y1: 17.178,
  x2: 11.055,
  y2: 21.863,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.665,
  stopColor: "#EB5837"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#79220E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 38.003,
  y1: 8.522,
  x2: 40.381,
  y2: 10.907,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.696,
  stopColor: "#EB5837"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#79220E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 2.669,
  y1: 13.034,
  x2: 6.221,
  y2: 18.049,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE0AC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FB9346"
})))));
export default SvgCar;